import { setAccessToken, setRefreshPath } from './api';

export type SessionUser = { id: string; email: string; displayName: string };

let currentUser: SessionUser | null = null;

export function setSession(accessToken: string, user: SessionUser): void {
  setAccessToken(accessToken);
  currentUser = user;
}

export function clearSession(): void {
  setAccessToken(null);
  currentUser = null;
}

export function getSessionUser(): SessionUser | null {
  return currentUser;
}

export type AdminUser = { id: string; email: string; displayName: string };

let currentAdmin: AdminUser | null = null;

export function setAdminSession(accessToken: string, adminUser: AdminUser): void {
  setAccessToken(accessToken);
  setRefreshPath('/v1/admin/auth/refresh');
  currentAdmin = adminUser;
}

export function clearAdminSession(): void {
  setAccessToken(null);
  setRefreshPath('/v1/auth/refresh');
  currentAdmin = null;
}

export function getAdminUser(): AdminUser | null {
  return currentAdmin;
}

export type KioskSession = {
  deviceLabel: string;
  property: { id: string; name: string };
};

const KIOSK_TOKEN_KEY = 'kiosk-access-token';
const KIOSK_SESSION_KEY = 'kiosk-session';

let currentKiosk: KioskSession | null = null;

// Restore kiosk session from sessionStorage on module load.
// sessionStorage survives page refresh but is cleared on tab close, which is
// the right behaviour for a shared kiosk device.
const _storedToken = sessionStorage.getItem(KIOSK_TOKEN_KEY);
const _storedSession = sessionStorage.getItem(KIOSK_SESSION_KEY);
if (_storedToken !== null && _storedSession !== null) {
  try {
    currentKiosk = JSON.parse(_storedSession) as KioskSession;
    setAccessToken(_storedToken);
  } catch {
    sessionStorage.removeItem(KIOSK_TOKEN_KEY);
    sessionStorage.removeItem(KIOSK_SESSION_KEY);
  }
}

export function setKioskSession(accessToken: string, session: KioskSession): void {
  setAccessToken(accessToken);
  currentKiosk = session;
  sessionStorage.setItem(KIOSK_TOKEN_KEY, accessToken);
  sessionStorage.setItem(KIOSK_SESSION_KEY, JSON.stringify(session));
}

export function clearKioskSession(): void {
  setAccessToken(null);
  currentKiosk = null;
  sessionStorage.removeItem(KIOSK_TOKEN_KEY);
  sessionStorage.removeItem(KIOSK_SESSION_KEY);
}

export function getKioskSession(): KioskSession | null {
  return currentKiosk;
}
